import { useHead } from '@unhead/react'
import { absoluteUrl, DEFAULT_DESCRIPTION, DEFAULT_TITLE, HERO_IMAGE, SITE_NAME } from '@/lib/site'

type SeoProps = {
  title?: string
  description?: string
  path?: string
  image?: string
  type?: 'website' | 'article'
}

export default function Seo({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  path = '/',
  image = HERO_IMAGE,
  type = 'website',
}: SeoProps) {
  const url = absoluteUrl(path)
  const fullTitle = title === DEFAULT_TITLE ? title : `${title} | ${SITE_NAME}`

  useHead({
    title: fullTitle,
    htmlAttrs: { lang: 'pt-BR' },
    meta: [
      { name: 'description', content: description },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Muita Mídia LTDA' },
      { name: 'keywords', content: 'comprar perfil instagram, comprar perfil no instagram, comprar página instagram, venda de perfis instagram, perfil instagram à venda' },
      { property: 'og:type', content: type },
      { property: 'og:title', content: fullTitle },
      { property: 'og:description', content: description },
      { property: 'og:url', content: url },
      { property: 'og:image', content: image },
      { property: 'og:locale', content: 'pt_BR' },
      { property: 'og:site_name', content: SITE_NAME },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: fullTitle },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: image },
    ],
    link: [{ rel: 'canonical', href: url }],
  })

  return null
}
